module.exports = require("./../../_gen/starling/assets/SoundFactory");